exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.grid-container[data-v-d337862a] {\n  display: grid;\n  row-gap: 10px;\n  -webkit-column-gap: 10px;\n     -moz-column-gap: 10px;\n          column-gap: 10px;\n  grid-template-columns: 1fr 1fr;\n  grid-auto-rows: 1fr;\n}\n@media (min-width:768px) {\n.service-title[data-v-d337862a] {\n    font-size: 14px;\n}\n}\n@media (min-width:1024px) {\n.service-title[data-v-d337862a] {\n    font-size: 15px;\n}\n}\n@media (min-width:1280px) {\n.service-title[data-v-d337862a] {\n    font-size: 16px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-d337862a","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/qChang/Step2.vue
// module id = 2381
// module chunks = 0